import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 15v-12","key":"svg-0"}],["path",{"d":"M16 7l-4 -4l-4 4","key":"svg-1"}],["path",{"d":"M3 12a9 9 0 0 0 18 0","key":"svg-2"}]]

const IconArrowDownFromArc = createReactComponent('outline', 'arrow-down-from-arc', 'ArrowDownFromArc', __iconNode);

export default IconArrowDownFromArc;